module.exports = __webpack_public_path__ + "img/3g.781b9d13.svg";